import { render } from "./AdminPodRequests.vue?vue&type=template&id=1d33749a&scoped=true"
import script from "./AdminPodRequests.vue?vue&type=script&lang=js"
export * from "./AdminPodRequests.vue?vue&type=script&lang=js"

import "./AdminPodRequests.vue?vue&type=style&index=0&id=1d33749a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d33749a"]])

export default __exports__